import type { ColorTokens } from "./tokens";

// 토큰 키(camelCase) → CSS 변수 세그먼트(kebab). buildCssVars의 변수명 생성과
// Storybook 토큰 갤러리의 var() 참조가 같은 변환을 쓰도록 export한다.
export const kebab = (s: string): string => s.replace(/([A-Z])/g, "-$1").toLowerCase();

const flatten = (
  obj: Record<string, unknown>,
  path: string[] = [],
): Array<[string[], string | number]> => {
  const result: Array<[string[], string | number]> = [];
  for (const [key, value] of Object.entries(obj)) {
    const next = [...path, key];
    if (typeof value === "string" || typeof value === "number") {
      result.push([next, value]);
    } else if (value !== null && typeof value === "object") {
      result.push(...flatten(value as Record<string, unknown>, next));
    }
  }
  return result;
};

export const buildCssVars = (prefix: string, tokens: Record<string, unknown>): string => {
  return flatten(tokens)
    .map(([path, value]) => `  --c6-${prefix}-${path.map(kebab).join("-")}: ${value};`)
    .join("\n");
};

export const buildColorCssVars = (tokens: ColorTokens): string => {
  return buildCssVars("color", tokens as unknown as Record<string, unknown>);
};
